// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "textOverflow-kg5iWk": "textOverflow-xlyipyv",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/resources/typography/Title.res.js:9"
  },
  h0: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1x01tnw",
    $$css: "wino-gc:src/resources/typography/Title.res.js:13"
  },
  h1: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1bdz40l",
    $$css: "wino-gc:src/resources/typography/Title.res.js:17"
  },
  h2: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1odaqk",
    $$css: "wino-gc:src/resources/typography/Title.res.js:21"
  },
  h3: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x11yzmoy",
    $$css: "wino-gc:src/resources/typography/Title.res.js:25"
  },
  h4: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-xbldpg",
    $$css: "wino-gc:src/resources/typography/Title.res.js:29"
  },
  h5: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-xsfa3gz",
    $$css: "wino-gc:src/resources/typography/Title.res.js:33"
  },
  h6: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x10l0f84",
    $$css: "wino-gc:src/resources/typography/Title.res.js:37"
  },
  alignLeft: {
    "textAlign-k9WMMc": "textAlign-xdpxx8g",
    $$css: "wino-gc:src/resources/typography/Title.res.js:41"
  },
  alignCenter: {
    "textAlign-k9WMMc": "textAlign-x2b8uid",
    $$css: "wino-gc:src/resources/typography/Title.res.js:44"
  },
  alignRight: {
    "textAlign-k9WMMc": "textAlign-x1hr2gdg",
    $$css: "wino-gc:src/resources/typography/Title.res.js:47"
  }
};
function styleFromLevel(level) {
  if (level === 1) {
    return styles.h1;
  } else if (level === 2) {
    return styles.h2;
  } else if (level === 3) {
    return styles.h3;
  } else if (level === 4) {
    return styles.h4;
  } else if (level === 5) {
    return styles.h5;
  } else if (level === 6) {
    return styles.h6;
  } else {
    return styles.h0;
  }
}
function styleFromAlign(align) {
  if (align === "start") {
    return styles.alignLeft;
  } else if (align === "center") {
    return styles.alignCenter;
  } else {
    return styles.alignRight;
  }
}
function styleFromWeight(weight) {
  return [weight !== undefined ? weight === "semibold" ? {
    fontWeight: 600
  } : weight === "medium" ? {
    fontWeight: 500
  } : weight === "regular" ? {
    fontWeight: 400
  } : {
    fontWeight: 700
  } : {}];
}
function styleFromMinChar(minChar) {
  if (minChar !== undefined) {
    return {
      whiteSpace: "nowrap",
      minWidth: minChar.toString() + `ch`
    };
  } else {
    return {};
  }
}
function styleProps(level, align, weight, italic, color, minChar, wrap) {
  let tmp = {
    fontStyle: italic ? "italic" : "normal",
    paddingRight: italic ? "1px" : "none"
  };
  if (color !== undefined) {
    tmp.color = Primitive_option.valFromOption(color);
  }
  return Stylex.props(styles.root, styleFromLevel(level), styleFromAlign(align), styleFromWeight(weight), styleFromMinChar(minChar), wrap ? {} : {
    whiteSpace: "nowrap"
  }, tmp);
}
function Title(props) {
  let __wrap = props.wrap;
  let __italic = props.italic;
  let __align = props.align;
  let __level = props.level;
  let children = props.children;
  let level = __level !== undefined ? __level : 1;
  let align = __align !== undefined ? __align : "start";
  let italic = __italic !== undefined ? __italic : false;
  let wrap = __wrap !== undefined ? __wrap : true;
  let match = styleProps(level, align, props.weight, italic, props.color, props.minChar, wrap);
  let style = match.style;
  let className = match.className;
  if (level === 2) {
    return JsxRuntime.jsx("h2", {
      children: children,
      className: className,
      style: style
    });
  } else if (level === 3) {
    return JsxRuntime.jsx("h3", {
      children: children,
      className: className,
      style: style
    });
  } else if (level === 4) {
    return JsxRuntime.jsx("h4", {
      children: children,
      className: className,
      style: style
    });
  } else if (level === 5) {
    return JsxRuntime.jsx("h5", {
      children: children,
      className: className,
      style: style
    });
  } else if (level === 6) {
    return JsxRuntime.jsx("h6", {
      children: children,
      className: className,
      style: style
    });
  } else {
    return JsxRuntime.jsx("h1", {
      children: children,
      className: className,
      style: style
    });
  }
}
let make = React.memo(Title);
export { make };
/* styles Not a pure module */